var $e4057c322613cd76$exports = {};
$e4057c322613cd76$exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};


export {$e4057c322613cd76$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
